module.exports = __webpack_public_path__ + "static/media/norecordfound.cd0936b4.webp";